import qs from 'qs'
import axios from '@/api/apiClient'
/**
 * 上传文件api
 */
const api = {
  wxcode: 'https://api.yzdli.com/applet/wechat/getwxacode',
  createShare: '/api/share/encodeContent',
  updateStatus: '/api/share/update/status',
}
export default api
// /**
//  * 分享
//  * @param {*} param.scene 参数 示例：如果是小程序线上展览,则传展览code,OLE20200713_43255007
//  * @param {*} param.pagePath 小程序页面路径 pages/index/onlineExhibit/onLinedetails/index 小程序线上展览
//  */
export const getShareWXcode = (query) => {
  return axios.$get(`${api.wxcode}${query ? `?${qs.stringify(query)}` : ''}`)
}
// /**
//  * 创建分享
//  * @param {*} param.shareChannel 分享类型 webchat_friend:微信好友 webchat_dynamic:微信朋友圈
//  * @param {*} param.shareType 分享渠道 exhibitionInfoOnLineShare : 云上展览
// exhibitionInfoOffLineShare : 线下展览
// liveShare : 直播
// memberCardShare : 名片
// productShare : 产品
// threeDExhibitionShare : 3D云展
// threeDProductShare : 3D产品
// meetingShare : 会议
// informationShare : 资讯
// modelShare: 模型
// postShare: 海报
// exhibitionExhibitorShare: 分享参展商
// * @param {*} param.shareParam
//  */
export const getCreateShare = (query) => {
  return axios.$get(`${api.createShare}${query ? `?${qs.stringify(query)}` : ''}`)
}

export const putUpdateStatus = (shareId) => {
  return axios.$put(`${api.updateStatus}/${shareId}`)
}

/**
 * 生成分享请求密文
 * @param {*} param
 */
export const postWechatShareParam = (param) => {
  return axios.$post(`${api.createShare}`, param)
}

// 外呼推送二维码加密接口
export const postOutboundShare = (param) => {
  return axios.$post(`/api/outBoundBot/encodeContent`, param)
}
